import http, { expandURI } from '@/utils/ajax'
import { COMMONS_INIT_LOADING, COMMONS_INIT_SUCCESS, COMMONS_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async commonsInit({ commit, state }) {
    commit(COMMONS_INIT_LOADING)
    const apiUrl = this.state.app.menu.commons
    const expand = {}
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(COMMONS_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(COMMONS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(COMMONS_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
